import React, { Component } from "react";
import CapabilityContextProvider from "../overview/context/CapabilityContext";
import RouteContextProvider from "./context/RouteContextProvider";
import OutboundOverviewAMZLView from "./OutboundOverviewAMZLView";
import OutboundFilterContextProvider from "./context/OutboundFilterContext";
import WaveViewSelector from "./routegridview/WaveViewSelector";
import RouteGridView from "./routegridview/RouteGridView";
import OutboundFilter from "./OutboundFilter";
import OutboundConfigContextProvider from "./context/OutboundConfigContext";
import PageHeader from "../PageHeader";
import { PAGE_HEADERS } from "../util/Constants";
import OutboundBanner from "./OutboundBanner";
import AlertView from "./AlertView";
import AlertContextProvider from "./context/AlertContext";
import DWPMetadataContextProvider from "./context/DWPMetadataContext";

class OutboundOverviewAMZL extends Component {
  render() {
    return (
      <CapabilityContextProvider>
        <OutboundFilterContextProvider>
          <DWPMetadataContextProvider>
            <AlertContextProvider>
              <OutboundBanner />
              <AlertView />
              <OutboundConfigContextProvider>
                <PageHeader {...PAGE_HEADERS.OUTBOUND} />
                <OutboundFilter />
                <RouteContextProvider>
                  <OutboundOverviewAMZLView />
                  <WaveViewSelector />
                  <RouteGridView />
                </RouteContextProvider>
              </OutboundConfigContextProvider>
            </AlertContextProvider>
          </DWPMetadataContextProvider>
        </OutboundFilterContextProvider>
      </CapabilityContextProvider>
    );
  }
}

export default OutboundOverviewAMZL;



// WEBPACK FOOTER //
// ./src/components/outboundAmzl/OutboundOverviewAMZL.js